// extracted by css-extract-rspack-plugin
export default {"name":"tcKRS","section":"TXNse","description":"HZykL","nameInput":"irA8E","descriptionInput":"Ahv89"};